import React from 'react'

import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'

import './CornerTagOverlayComponentChyronStyle.scss'

type CornerTagOverlayComponentProps = {
  text: string
}

const CornerTagOverlayComponent = ({
  text,
}: CornerTagOverlayComponentProps) => {
  const { accent } = useWebinarColors()
  return (
    <div
      className="corner-tag-overlay-component-chyron-style"
      style={{ '--accent-color': accent }}
    >
      <div className="text">{text}</div>
    </div>
  )
}

export default CornerTagOverlayComponent
